import React from 'react';
import { WeeklyCalendar } from '../../../components';

export const EmpBookingWeeklyCalendar = ({ weekdates = {}, data = {} }) => {

    return (
        <WeeklyCalendar weekdates={weekdates} data={data} />
    )
}
